import { Badge } from "@spz/ui/components/badge";
import { EmptyCell } from "@spz/ui/components/table/cells/EmptyCell";
import { TruncatedText } from "@spz/ui/components/truncated-text";
import type { ConclusionCellProps } from "../types";

export const ConclusionCell: React.FC<ConclusionCellProps> = ({
  value,
  className,
}) => {
  if (!value) return <EmptyCell />;

  return (
    <Badge variant={"tag"} className="bg-gray-100 text-gray-800 border-none">
      <TruncatedText className="w-10 font-semibold text-center" maxLines={1}>
        {value}
      </TruncatedText>
    </Badge>
  );
};
